"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "className", "theme", "testId"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  onRemove: function onRemove() {},
  theme: {}
};

/**
 * Used for displaying closeable pills/tags.
 */
var Pill = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Pill, _React$Component);
  function Pill(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Pill);
    _this = _callSuper(this, Pill, [props]);
    _this.handleRemove = _this.handleRemove.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Pill, [{
    key: "handleRemove",
    value: function handleRemove(e) {
      e.preventDefault();
      e.stopPropagation();
      this.props.onRemove();
    }
  }, {
    key: "renderRemoveButton",
    value: function renderRemoveButton() {
      var _this$props = this.props,
        disabled = _this$props.disabled,
        testId = _this$props.testId;
      if (disabled) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.handleRemove,
        "data-test-id": testId && "".concat(testId, "-remove"),
        "aria-label": "Remove",
        className: "remove-button"
      }, "\xD7");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        theme = _this$props2.theme,
        testId = _this$props2.testId,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      delete props.onRemove;
      delete props.disabled;
      return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
        className: (0, _classnames["default"])(className, theme.pill),
        "data-test-id": testId,
        "data-anypoint-component": "Pill"
      }, props), children, this.renderRemoveButton());
    }
  }]);
  return Pill;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Pill, "defaultProps", defaultProps);
//# sourceMappingURL=Pill.js.map